import { updateUrlHash } from "@vega-core/utils/url.helper";

type ScrollToElementOptions = {
  offset?: number;
  behavior?: ScrollBehavior;
  hash?: string;
};

export const scrollToElementWithOffset = (
  elementId: string,
  { offset = 0, behavior = "smooth", hash }: ScrollToElementOptions = {},
): boolean => {
  const element = document.getElementById(elementId);

  if (!element) {
    console.warn(`Element with id "${elementId}" not found`);

    return false;
  }

  if (hash) {
    updateUrlHash(hash);
  }

  const elementPosition = element.getBoundingClientRect().top + window.scrollY;
  const offsetPosition = elementPosition - offset;

  window.scrollTo({
    top: offsetPosition,
    behavior,
  });

  return true;
};
